import { render, staticRenderFns } from "./super-school-explain.vue?vue&type=template&id=3373cdf7&scoped=true&"
import script from "./super-school-explain.vue?vue&type=script&lang=ts&"
export * from "./super-school-explain.vue?vue&type=script&lang=ts&"
import style0 from "./super-school-explain.vue?vue&type=style&index=0&id=3373cdf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373cdf7",
  null
  
)

export default component.exports